const mutations = {
    setRlImageCloseDialog(state, payload){
      state.rlImageCloseDialog = payload
    },
    setRlEntryAddDialogView2(state, payload){
      state.rlEntryAddDialogView2 = payload
    },
    setRemember(state, payload){     
      if(payload){
        localStorage.setItem('remember', true)
      }else{
        localStorage.setItem('remember', false)
      }     
    },
    setErrorMessage(state, payload){
      state.errorMessage = payload
    },
    setRlEditNote(state, payload){
      state.rlEditNote = payload     
    },
    setRlEntry(state, payload) {
      state.rlEntry = payload
    },
    setRlEntryList(state, payload) {
      state.rlEntryList = payload
    },
    setRlEntryTable(state, payload) {
      state.rlEntryTable = payload
    },
    setRlEntryTableOptions(state, payload) {
      state.rlEntryTableOptions = payload
    },
    setRlAddDialog(state, payload) {
      state.rlAddDialog = payload
    },
    setRlAddDialogList(state, payload) { 
      (Array.isArray(payload))?
        payload.forEach(item => {
          state.rlAddDialogList.push(Object.assign({}, item)) 
        })
      :
        state.rlAddDialogList.push(Object.assign({}, payload))        
    },
    clearRlAddDialogList(state, payload){
      state.rlAddDialogList = [];
    },
    deleteRlAddDialogList(state, payload) {
      const index = state.rlAddDialogList.indexOf(payload)
      state.rlAddDialogList.splice(index, 1)
    },
    setRlEditDialog(state, payload) {
      state.rlEditDialog = payload
    },
    setRlDeleteDialog(state, payload) {
      state.rlDeleteDialog = payload
    },
    setRlImageAddDialog(state, payload) {
      state.rlImageAddDialog = payload
    },
    setRlImageSaveDialog(state, payload) {
      state.rlImageSaveDialog = payload
    },
    setRlImageEditDialog(state, payload) {
      state.rlImageEditDialog = payload
    },
    setRlImageFullSizeDialog(state, payload) {
      state.rlImageFullSizeDialog = payload
    },
    setUser(state, payload) {
      state.user = payload
      localStorage.setItem('User', JSON.stringify(payload))
    },
    deleteUser() {
      localStorage.removeItem('remember')
      localStorage.removeItem('User')
    },
    setLoginAlert(state, payload) {
      state.loginAlert = payload
    },
    setLicenseList(state, payload){    
      state.licenseList = payload
    },
    setRoleList(state, payload) {
      state.roleList = payload
    },
    setPermissionList(state, payload) {
      state.permissionList = payload
    },
    setEntryTypeList(state, payload) {
      state.entryTypeList = payload
    },
    setMaterialList(state, payload) {
      state.materialList = payload
    },
    setGradeList(state, payload) {
      state.gradeList = payload
    },
    setIncotermList(state, payload) {
      state.incotermList = payload
    },
    setCurrencyList(state, payload) {
      state.currencyList = payload
    },
    setHs2List(state, payload) {
      state.hs2List = payload
    },
    setDomesticCompanyList(state, payload) {
      state.domesticCompanyList = payload
    },
    setShippingCompanyList(state, payload) {
      state.shippingCompanyList = payload
    },
    setInspectionCompanyList(state, payload) {
      state.inspectionCompanyList = payload
    },
    setCountryList(state, payload) {
      state.countryList = payload
    },
    setUnitOfMeasureList(state, payload) {
      state.unitOfMeasureList = payload
    },
    setRecyclingLedgerEntryList(state, payload) {
      state.recyclingLedgerEntryList = payload
    },
    setRecyclingLedgerEntry(state, payload) {
      state.recyclingLedgerEntryList.push(payload)
    },
    deleteRecyclingLedgerEntry(state, payload) {
      const index = state.recyclingLedgerEntryList.indexOf(payload)
      state.recyclingLedgerEntryList.splice(index, 1)
    },
    setCompanyList(state, payload) {
      state.companyList = payload
    },
    setPBIReportList(state, payload) {
      state.pbiReportList = payload
    },
    setPBIToken(state, payload) {
      state.pbiTokenList.push(payload)
    },
    setShowVerificationMessage(state, payload) {
      state.showVerificationMessage = payload
    },
    deletePBIToken(state, payload) {     
      const list = JSON.parse(JSON.stringify(state.pbiTokenList))     
      let token = list.find(x => x.report_id === payload)         
      const index = list.indexOf(token)        
      state.pbiTokenList.splice(index, 1)
    },    
}

export default mutations